import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useBrandConfig } from "@/hooks/useBrandConfig";
import { useBrandConfigStore } from "@/hooks/brandConfigStore";
import { useEffect } from "react";

type BrandSearch = {
  brand?: string;
}

export const Route = createFileRoute("/(welcome-gift)/welcome-gift")({
  validateSearch: (search: Record<string, unknown>): BrandSearch => {
    return {
      brand: search.brand?.toString()
    }
  },
  component: WelcomeGiftLayout,
});

function WelcomeGiftLayout() {
  const { brand: brandParam } = Route.useSearch();
  const hostname = window.location.hostname.toLowerCase().includes("satumeja")
    ? "satumeja"
    : window.location.hostname.split('.')[0];
  const brandKey = brandParam || hostname;

  const { data } = useBrandConfig(brandKey);
  const { setConfig, config } = useBrandConfigStore();
  document.title = ""

  useEffect(() => {

    if (data) {
      setConfig(data);

      if (data.brandTitle) {
        document.title = data.brandTitle;
      }

      if (data.faviconUrl) {
        let link: HTMLLinkElement | null = document.querySelector("link[rel~='icon']");
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = data.faviconUrl;
      }
    }
  }, [data, setConfig]);

  if (!config) return null;

  return <Outlet />;
}